<template>
  <!-- 夜审信息弹框 -->
  <div class="examine-info">
    <el-dialog :title="$t('common.startANightTrial')" :append-to-body="true"
      :visible.sync="infoVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="beforeClose" @closed="closed" width="600px" class="info-dialog">
      <template>
        <div class="info-body">
          <ul :class="overCheck ? '' : 'hoverClass'">
            <li v-for="(item, itemIndex) of nightAuditItemList" v-show="item.isActive || errStep === itemIndex + 1"
              :key="itemIndex">
              <h3>{{ itemIndex + 1 }}.{{ item.label }}</h3>
              <div v-for="(content, contentIndex) in item.contents" :key="contentIndex">
                <p>{{ content.content }}</p>
              </div>
              <p v-if="errStep && errStep === itemIndex + 1" class="errorp">{{
                $t('componentsNightauditGrayEnv.procedure') }}{{ errStep }}{{ $t('componentsNightauditGrayEnv.mistake')
                }}</p>
            </li>
          </ul>
        </div>
      </template>
      <p v-if="errStep" class="redp">
        <i class="el-icon-warning" />
        {{ $t('componentsNightauditGrayEnv.carryOut') }}{{ errStep }}{{
          $t('componentsNightauditGrayEnv.whenAnErrorOccursTheNightAuditStopsPleaseConfirmItCarefully') }}
      </p>
      <p v-if="errStep" class="redp">
        <i class="el-icon-warning" /> {{
          $t('componentsNightauditGrayEnv.nightAuditFailureToEncounterProblemsCanBeInTheMorningAfter8OclockAsSoonAsPossibleToContactTechnicalSupportToHelpSolve')
        }}
      </p>
      <div slot="footer" class="dialog-footer">
        <p-button :name="$t('common.close')" class-name="btn-dialog"
          :color-class="overCheck ? '' : 'color-noable'" @handle-active="closeAuditDialog" />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { deepClone, helpJsonParse } from '@/utils/index'
import { nightAuditItemList_gray_env as nightAuditItemList } from '@/utils/enum'
export default {
  name: 'NightAuditGrayEnv',
  data() {
    return {
      infoVisible: false,
      errStep: '',
      nightAuditItemList: deepClone(nightAuditItemList),
      isHandChange: false
    }
  },
  computed: {
    overCheck() {
      return this.errStep || this.nightAuditItemList[this.nightAuditItemList.length - 1].contents.length
    }
  },
  watch: {
    '$store.getters.socketMessage'(resData) {
      const { type, childrenType, context = '' } = resData
      if (type === 'socket' && childrenType === 'nightTrial') {
        const resContext = helpJsonParse(context) || {}
        console.log(this.$t("componentsNightauditGrayEnv.nightTrialNewsNotice2"), resContext)
        if (resContext.nightTrialStep && resContext.nightTrialStep.includes('nightTrialStep')) {
          return
        }
        const { content, step = '', errorStep = '' } = resContext
        if (!this.infoVisible) {
          this.$store.commit('user/SET_NIGHT_AUDIT_STATUS', {
            data: 'show',
            isSetLocalStorage: true
          })
          this.infoVisible = true
        }
        if (errorStep) {
          this.$store.commit('app/SET_REFRESH', true)
          this.errStep = errorStep
          return
        }
        if (!resContext.content) {
          return
        }
        if (step === 1 || this.errStep === step) {
          this.errStep = ''
          if (step === 1) { // 第一步夜审开始，重置夜审日志
            this.nightAuditItemList = deepClone(nightAuditItemList)
          }
        }
        const currentStep = this.nightAuditItemList[step - 1]
        if (currentStep) {
          currentStep.isActive = true
          currentStep.contents = helpJsonParse(content).contents
          if (step === nightAuditItemList.length) {
            this.$store.commit('app/SET_REFRESH', true)
          }
        }
      }
    },
    '$store.getters.nightAuditStatus'(value) {
      if (!value) {
        this.infoVisible = false
      }
    }
  },
  methods: {
    beforeClose(done) {
      if (this.overCheck) {
        done()
      }
    },
    closed() {
      if (!this.errStep && this.isHandChange) {
        this.$store.commit('user/SET_SHIFTS', {
          data: null
        })
      }
      this.isHandChange = false
      this.errStep = ''
    },
    closeAuditDialog() {
      if (this.overCheck) {
        this.isHandChange = true
        this.infoVisible = false
        this.$store.commit('user/SET_NIGHT_AUDIT_STATUS', {
          data: '',
          isSetLocalStorage: true
        })
        this.$store.commit('app/SET_REFRESH', true)
        this.nightAuditItemList = deepClone(nightAuditItemList)
        if (!this.errStep) {
          localStorage.removeItem('userShifts')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info-dialog {
  .el-dialog .el-dialog__body {
    padding: 20px 40px;
  }

  .info-body {
    padding: 20px;
    background: rgba(242, 241, 241, 1);

    li {
      margin-bottom: 20px;
    }

    li:last-child {
      margin-bottom: 0;
    }

    h3 {
      font-size: 16px;
      font-weight: 500;
      color: rgba(35, 37, 58, 1);
      line-height: 17px;
      margin-bottom: 13px;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: rgba(35, 37, 58, 1);
      line-height: 20px;
    }
  }
}

.info-dialog .info-body .errorp {
  color: #fc6830;
}

.redp {
  color: #ff5736;
  font-size: 14px;
  margin-top: 20px;
}

.hoverClass:hover {
  cursor: not-allowed;
}
</style>
